import styled, { css } from 'styled-components';
import { Swiper } from 'swiper/react';

import type { ProductTypeOptions } from '@/types/product';

import { Box } from '@/components/Box';

import zoomCursor from '@/assets/cursor-zoom.png';

export const Wrapper = styled(Box)`
  position: relative;
  height: 100%;
  ${({ theme }) => css`
    ${theme.media.md.down} {
      /* Square by default. An ancestor can shrink the whole carousel by setting
         --carousel-mobile-height; BEC-24926 uses 90vw on the PDP gallery. */
      height: var(--carousel-mobile-height, 100vw);
    }
  `}
`;

export const StyledSwiper = styled(Swiper)<{ type: ProductTypeOptions }>`
  ${({ theme }) => css`
    .swiper-scrollbar {
      bottom: 0;
      background: ${({ theme }) => theme.colors.lightGray};
    }
    .swiper-scrollbar-drag {
      background: ${theme.colors.primaryDark};
    }
    ${theme.media.md.down} {
      .next-image {
        height: var(--carousel-mobile-height, 100vw);
      }
    }
  `}

  &.swiper {
    height: var(--carousel-mobile-height, 100vw);
    ${({ theme }) => css`
      @media (min-width: ${theme.breakpoints.md}) {
        max-height: 645px;
      }

      @media (min-width: 1200px) {
        max-height: 695px;
      }
    `}

    &-slide {
      text-align: center;
      overflow: hidden;
      height: auto;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    &-scrollbar {
      background: ${({ theme }) => theme.colors.navyBlue};
      height: 2px;
      bottom: 0;
      width: 100%;

      &-drag {
        background: ${({ theme }) => theme.colors.primary};
      }
    }
  }
`;

export const Navigation = styled.span<{ type: 'next' | 'prev' }>`
  position: absolute;
  z-index: 1;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: all;

  ${({ theme, type }) => css`
    padding: ${theme.spacing(1.5)};
    ${type === 'next' ? 'right' : 'left'}: 0;
  `}

  :hover {
    cursor: pointer;
    background-color: ${({ theme }) => theme.colors.primaryDark};

    svg > path {
      fill: ${({ theme }) => theme.colors.white};
    }
  }

  svg {
    height: 38px;

    path {
      fill: ${({ theme }) => theme.colors.primaryDark};
    }
  }

  &.swiper-button {
    &-disabled {
      svg path {
        fill: ${({ theme }) => theme.colors.defaultAdd4};
      }

      &:hover {
        cursor: not-allowed;
      }
    }
  }
`;

export const PhotoSwipeLink = styled.a<{ isProcessing: boolean }>`
  ${({ isProcessing }) =>
    css`
      cursor: ${isProcessing
        ? 'wait'
        : `url(${zoomCursor.src}) 25 25, zoom-in`};
    `}
`;
